import PrivacityTerm from 'modules/terms/PrivacityTerm'
import React from 'react'

export default function UseTerms() {
  return (
    <PrivacityTerm />
  )
}
